import { Link } from 'react-router-dom';
import type { EventItem } from '@/mocks/events';
import { formatDate, formatViews } from '@/utils/news';

interface EventCardProps {
  event: EventItem;
  index?: number;
}

export default function EventCard({ event, index }: EventCardProps) {
  return (
    <Link
      to={`/detail/${event.id}`}
      className="animate-float-up group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
      style={index !== undefined ? { animationDelay: `${index * 40}ms` } : undefined}
    >
      <div className="relative w-full h-48 overflow-hidden bg-secondary-100">
        <img
          src={event.cover}
          alt={`${event.title} 网红赛事封面`}
          title={`${event.title} - 网红大赛`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
          <i className="ri-fire-fill text-[10px]"></i>
          {event.categoryName}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {event.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
          {event.summary}
        </p>
        <div className="mt-3 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {formatDate(event.date)}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(event.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}